import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = { class: "dropdown" }
const _hoisted_9 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "fa fa-fw fa-eye me-2"
}
const _hoisted_13 = {
  key: 1,
  class: "fa fa-fw fa-spinner fa-spin me-2"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "fa fa-fw fa-print me-2"
}
const _hoisted_17 = {
  key: 1,
  class: "fa fa-fw fa-spinner fa-spin me-2"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "pagination-area d-md-flex mt-15 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "btn btn-primary",
          to: "/ventes/ajouter-vente"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
            _createTextVNode(" Ajouter une vente ")
          ])),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          class: "search-bg svg-color pt-3",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black",
            placeholder: "Rechercher une vente"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("button", {
            type: "submit",
            class: "bg-transparent text-primary transition p-0 border-0"
          }, [
            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
          ], -1))
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Date"),
              _createElementVNode("th", null, "Reference"),
              _createElementVNode("th", null, "Client"),
              _createElementVNode("th", null, "Type Commande"),
              _createElementVNode("th", null, "Type Facture"),
              _createElementVNode("th", null, "ACTIONS")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ventes, (vente, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(vente?.dateCommande)), 1),
                _createElementVNode("td", null, _toDisplayString(vente?.refCom), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.getClientName(vente?.client)), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", {
                  'bg-primary': vente.typeCommande === 'Au comptoir',
                  'bg-warning': vente.typeCommande === 'Sur commande'
                }])
                  }, _toDisplayString(vente?.typeCommande), 3)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", {
                  'bg-light text-dark': vente.typeFacture === 'Facture de vente',
                  'bg-success': vente.typeFacture === 'Facture de vente à l\'exportation',
                  'bg-info': vente.typeFacture === 'Facture proforma'
                }])
                  }, _toDisplayString(vente?.typeFacture), 3)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[8] || (_cache[8] = _createElementVNode("button", {
                      class: "btn btn-primary dropdown-toggle",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "data-bs-popper-config": "{\"strategy\":\"fixed\"}"
                    }, " Actions ", -1)),
                    _createElementVNode("ul", _hoisted_9, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item d-flex align-items-center",
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.imprimerBon(vente.id))
                        }, _cache[5] || (_cache[5] = [
                          _createElementVNode("i", { class: "fa fa-fw fa-file-text-o me-2" }, null, -1),
                          _createTextVNode("Imprimer Bon de Commande ")
                        ]), 8, _hoisted_10)
                      ]),
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'ViewVente', params: { id: vente.id } },
                          class: "dropdown-item d-flex align-items-center"
                        }, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createElementVNode("i", { class: "fa fa-fw fa-info-circle me-2" }, null, -1),
                            _createTextVNode("Détails ")
                          ])),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: _normalizeClass(["dropdown-item d-flex align-items-center", { 'disabled': _ctx.isPrintingApercu }]),
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.apercu(vente))
                        }, [
                          (!_ctx.isPrintingApercu)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                            : (_openBlock(), _createElementBlock("i", _hoisted_13)),
                          _createTextVNode(" " + _toDisplayString(_ctx.isPrintingApercu ? 'Génération...' : 'Aperçu'), 1)
                        ], 10, _hoisted_11)
                      ]),
                      (vente.typeFacture !== 'Facture proforma')
                        ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                            _createElementVNode("a", {
                              class: _normalizeClass(["dropdown-item d-flex align-items-center", { 'disabled': _ctx.isPrintingFacture }]),
                              href: "javascript:void(0);",
                              onClick: ($event: any) => (_ctx.imprimerFacture(vente))
                            }, [
                              (!_ctx.isPrintingFacture)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                                : (_openBlock(), _createElementBlock("i", _hoisted_17)),
                              _createTextVNode(" " + _toDisplayString(_ctx.isPrintingFacture ? 'Génération...' : 'Imprimer Facture'), 1)
                            ], 10, _hoisted_15)
                          ]))
                        : _createCommentVNode("", true),
                      (vente.statut !== 'Annulée')
                        ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                            _createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center text-danger",
                              href: "javascript:void(0);",
                              onClick: ($event: any) => (_ctx.annulerVente(vente))
                            }, _cache[7] || (_cache[7] = [
                              _createElementVNode("i", { class: "fa fa-fw fa-ban me-2" }, null, -1),
                              _createTextVNode("Annuler la Vente ")
                            ]), 8, _hoisted_19)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}